import React from 'react'
import Player from "@madzadev/audio-player";


import './Reproductor.scss';

const Reproductor = () => {
    const colors = `html {
        --tagsBackground: #9440f3;
        --tagsText: #ffffff;
        --tagsBackgroundHoverActive: #2cc0a0;
        --tagsTextHoverActive: #ffffff;
        --searchBackground: #18191f;
        --searchText: #ffffff;
        --searchPlaceHolder: #575a77;
        --playerBackground: #18191f;
        --titleColor: #ffffff; 
        --timeColor: #ffffff;
        --progressSlider: #9440f3;
        --progressUsed: #ffffff;
        --progressLeft: #151616;
        --volumeSlider: #9440f3;
        --volumeUsed: #ffffff;
        --volumeLeft:  #151616;
        --playlistBackground: #181f1b;
        --playlistText: #575a77;
        --playlistBackgroundHoverActive:  #18191f;
        --playlistTextHoverActive: #ffffff;
    }`;

    const tracks = [
        {
            url: "../../audios/page9-1.mp3",
            title: "01-Exercise 1 - Page 9",
            tags: ["house"],
        },
        {
            url: "../../audios/page10-2.mp3",
            title: "02-Exercise 2 - Page 10",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page12-4.mp3",
            title: "03-Exercise 4 - Page 12",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page17-1.mp3",
            title: "04-Exercise 1 - Page 17",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page18-2.mp3",
            title: "05-Exercise 2 - Page 18",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page21-5.mp3",
            title: "06-Exercise 5 - Page 21",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page22-7.mp3",
            title: "07-Exercise 7 - Page 22",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page25-3.mp3",
            title: "08-Exercise 3 - Page 25",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page26-5.mp3",
            title: "09-Exercise 5 - Page 26",
            tags: ["house"],
        },
        {
            url: "../../audios/page29-1.mp3",
            title: "10-Exercise 1 - Page 29",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page30-2.mp3",
            title: "11-Exercise 2 - Page 30",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page32-4.mp3",
            title: "12-Exercise 4 - Page 32",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page33-6.mp3",
            title: "13-Exercise 6 - Page 33",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page37-1.mp3",
            title: "14-Exercise 1 - Page 37",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page38-2.mp3",
            title: "15-Exercise 2 - Page 38",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page40-4.mp3",
            title: "16-Exercise 4 - Page 40",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page44-1.mp3",
            title: "17-Exercise 1 - Page 44",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page45-3.mp3",
            title: "18-Exercise 3 - Page 45",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page49-1.mp3",
            title: "19-Exercise 1 - Page 49",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page50-2.mp3",
            title: "20-Exercise 2 - Page 50",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page52-4.mp3",
            title: "21-Exercise 4 - Page 52",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page53-6.mp3",
            title: "22-Exercise 6 - Page 53",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page57-1.mp3",
            title: "23-Exercise 1 - Page 57",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page58-2.mp3",
            title: "24-Exercise 2 - Page 58",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page60-4.mp3",
            title: "25-Exercise 4 - Page 60",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page61-6.mp3",
            title: "26-Exercise 6 - Page 61",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page64-1.mp3",
            title: "27-Exercise 1 - Page 64",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page65-4.mp3",
            title: "28-Exercise 4 - Page 65",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page69-1.mp3",
            title: "29-Exercise 1 - Page 69",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page70-2.mp3",
            title: "30-Exercise 2 - Page 70",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page72-4.mp3",
            title: "31-Exercise 4 - Page 72",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page73-6.mp3",
            title: "32-Exercise 6 - Page 73",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page77-1.mp3",
            title: "33-Exercise 1 - Page 77",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page78-2.mp3",
            title: "34-Exercise 2 - Page 78",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page80-4.mp3",
            title: "35-Exercise 4 - Page 80",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page81-6.mp3",
            title: "36-Exercise 6 - Page 81",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page85-4.mp3",
            title: "37-Exercise 4 - Page 85",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page89-1.mp3",
            title: "38-Exercise 1 - Page 89",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page90-2.mp3",
            title: "39-Exercise 2 - Page 90",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page92-4.mp3",
            title: "40-Exercise 4 - Page 92",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page93-6.mp3",
            title: "41-Exercise 6 - Page 93",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page97-1.mp3",
            title: "42-Exercise 1 - Page 97",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page98-2.mp3",
            title: "43-Exercise 2 - Page 98",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page100-4.mp3",
            title: "44-Exercise 4 - Page 100",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page101-6.mp3",
            title: "45-Exercise 6 - Page 101",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page104-1.mp3",
            title: "46-Exercise 1 - Page 104",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page105-4.mp3",
            title: "47-Exercise 4 - Page 105",
            tags: ["dubstep"],
        }
    ];

    return (
        <Player 
            trackList={tracks}
            includeTags={false}
            ncludeSearch={true}
            showPlaylist={true}
            autoPlayNextTrack={true}
            customColorScheme={colors}
        />
    )
}

export default Reproductor